<template>
  <div class="menuFrame">
    <div class="container py-3">
      <div
        class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
      >
        <a href="https://www.chanchao.com.tw/vn/">
          <div class="d-flex align-items-center">
            <img
              src="../../assets/images/ChanChaoLogo.png"
              class="navLogo mt-2"
            />
            <div class="mx-2 logoText text-dark font-weight-nomal">
              <div>Hội viên Chan Chao</div>
            </div>
          </div>
        </a>

        <div>
          <select
            class="form-control language-select"
            v-model="selectedLang"
            @change="switchLanguage"
          >
            <option
              v-for="lang in languages"
              :key="lang.value"
              :value="lang.value"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 my-4 px-4">
          <div class="d-flex align-items-center mb-4">
            <img
              src="../../assets/images/signupIcon.png"
              class="mr-2 mb-2"
              style="width: 40px; height: 40px"
              alt=""
            />
            <h4 class="title_family">Đăng ký hội viên</h4>
          </div>

          <form>
            <div class="form-group h6">
              <label for="signupEmail" class="title_family"
                >Địa chỉ email<span class="input-note">
                  *Tài khoản hội viên không thể sửa đổi</span
                >
              </label>
              <input
                type="email"
                name="email"
                class="form-control form-group"
                placeholder="Xin hãy nhập chính xác email có thể nhận thư, hệ thống sẽ gửi mail xác thực cho bạn"
                id="signupEmail"
                maxlength="50"
                aria-describedby="emailHelp"
                v-model="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="signupEmail"
              />
              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('email')"
                >{{ errors.first("email") }}
              </span>
            </div>
            <div class="form-group h6">
              <label for="signupPassword" class="title_family"
                >Nhập mã xác thực<span class="input-note"> *</span></label
              >
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nhập mã xác thực gồm 6 ký tự"
                  id="signupPassword"
                  maxlength="6"
                  v-model="verificationcode"
                  name="text"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="signupPassword"
                />
                <div class="input-group-prepend">
                  <button
                    class="btn btn-secondary ml-3 py-0 px-3 rounded"
                    style="font-size: 16px"
                    @click.prevent="getverification"
                    type="button"
                  >
                    Lấy mã xác thực
                  </button>
                </div>
              </div>

              <div>
                <em style="font-size: 13px; color: grey"
                  >Nhấp vào【Lấy mã xác thực】, mã xác thực sẽ gửi đến email của
                  bạn</em
                >
              </div>

              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('text')"
                >Mã xác thực không được để trống
              </span>
            </div>
            <div class="form-group h6">
              <label for="signupName" class="title_family"
                >Họ tên<span class="input-note"> *</span></label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Vui lòng điền tên thật của bạn để xác nhận tại hiện trường"
                id="signupName"
                maxlength="30"
                v-model="name"
                name="name"
                :class="{ 'is-invalid': errors.first('name') }"
                v-validate="'required'"
                ref="signupName"
              />
              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('name')"
                >Họ tên không được để trống
              </span>
            </div>
            <div class="form-group h6">
              <label class="title_family"
                >Số di động<span class="input-note"> *</span></label
              >

              <vue-tel-input
                class="form-control"
                type="tel"
                v-bind="bindProps"
                placeholder=""
                v-model="allPhone"
                maxLen="20"
                name="interphone"
                :class="{ 'is-invalid': errors.first('interphone') }"
                v-validate="'required'"
              ></vue-tel-input>
              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('interphone')"
                >Số di động không được để trống
              </span>
            </div>

            <div class="form-group h6">
              <label for="signupPassword1" class="title_family"
                >Mật khẩu<span class="input-note"> *</span></label
              >

              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  name="password"
                  class="form-control"
                  placeholder="Mật khẩu 8-20 ký tự"
                  id="signupPassword1"
                  autocomplete="off"
                  maxlength="20"
                  v-model="password"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  ref="password"
                  data-vv-as="password"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    @click.prevent="showPw"
                  >
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i
                      class="fas fa-eye-slash"
                      v-else-if="typePwd == 'text'"
                    ></i>
                  </span>
                </div>
              </div>
              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('password')"
                >{{ errors.first("password") }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="signupPassword2" class="title_family"
                >Xác nhận mật khẩu<span class="input-note"> *</span></label
              >
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  class="form-control"
                  placeholder="Nhập lại mật khẩu"
                  id="signupPassword2"
                  autocomplete="off"
                  maxlength="20"
                  v-model="confirmpassword"
                  name="password_confirmation"
                  :class="{
                    'is-invalid': errors.first('password_confirmation'),
                  }"
                  v-validate="'required|confirmed:password'"
                  data-vv-as="password_confirmation"
                  ref="signupPassword2"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    @click.prevent="showPw"
                  >
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i
                      class="fas fa-eye-slash"
                      v-else-if="typePwd == 'text'"
                    ></i>
                  </span>
                </div>
              </div>
              <span
                class="text-danger title_family"
                style="font-size: 10px"
                v-if="errors.first('password_confirmation')"
              >
                {{ errors.first("password_confirmation") }}
              </span>
            </div>

            <div class="form-check ml-1">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="signupCheck"
                v-model="checkedrule"
                maxlength="20"
              />
              <label
                class="form-check-label"
                for="signupCheck"
                style="font-size: 15px"
              >
                <span>Đăng nhập đồng nghĩa với việc bạn đồng ý với【</span>
                <a
                  href="//www.chanchao.com.tw/en/otherMember.asp"
                  target="_blank"
                  >điều khoản dịch vụ</a
                ><span>】của chúng tôi</span>
                <span v-if="checkText" class="text-danger ml-1"
                  >**Vui lòng đánh dấu**</span
                >
              </label>
            </div>

            <button
              type="submit"
              class="btn btn-block btn-primary mt-4"
              @click.prevent="signupBtn"
            >
              Đăng ký
            </button>
          </form>

          <hr />
          <div class="linkFrame">
            <span>Bạn đã gia nhập hội viên Chan Chao? </span>
            <span>
              <router-link to="/vn/login">Hội viên đăng nhập</router-link>
            </span>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <div class="d-flex align-items-center mb-4">
            <img
              src="../../assets/images/user.svg"
              class="mr-3"
              style="width: 50px; height: 50px"
              alt=""
            />
            <div class="title_family">
              <h4>Đăng ký hội viên miễn phí</h4>
              <h6>Cập nhật thông tin triển lãm và chuyên ngành mọi lúc mọi</h6>
            </div>
          </div>
          <p>
            Nhanh chóng nắm bắt tin tức mới nhất về triển lãm, thông tin nhận vé
            sự kiện, ưu đãi và quyền lợi dành riêng cho hội viên Chan Chao, đồng
            thời nhận bản tin điện tử và báo cáo tin tức triển lãm miễn phí
          </p>

          <hr />

          <h4 class="my-4 title_family">Các câu hỏi thường gặp</h4>
          <ul class="ml-0 pl-4">
            <li>
              <a
                href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
                target="_blank"
                >Làm thế nào để trở thành hội viên?</a
              >
            </li>
            <li>
              <a
                href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
                target="_blank"
                >Làm thế nào để nhận vé? Mã mời tham quan là gì?</a
              >
            </li>
            <li>
              <a
                href="https://www.chanchao.com.tw/downloads/%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88)_En.pdf"
                target="_blank"
                >Làm thế nào để nhanh chóng quét mã vào cửa??</a
              >
            </li>
          </ul>

          <div class="d-flex mt-3">
            <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
              >Câu hỏi thường gặp khác<i
                class="fas fa-external-link-alt ml-2"
              ></i
            ></a>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer_en.vue";

export default {
  components: {
    Footer,
  },

  data() {
    return {
      mobile: "",
      mobilecountrycode: "",
      name: "",
      email: "",
      verificationcode: "",
      confirmpassword: "",
      password: "",
      allPhone: "",
      bindProps: {
        mode: "international",
        defaultCountry: "VN",
      },
      checkedrule: false,
      typePwd: "password",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      checkText: false,
      CSRF_Token: "",
      selectedLang: "vn",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    email: function () {
      const vm = this;
      vm.$refs.signupEmail.style.borderColor = "#ced4da";
    },

    verificationcode: function () {
      const vm = this;
      vm.$refs.signupPassword.style.borderColor = "#ced4da";
    },

    name: function () {
      const vm = this;
      vm.$refs.signupName.style.borderColor = "#ced4da";
    },

    password: function () {
      const vm = this;
      vm.$refs.password.style.borderColor = "#ced4da";
    },

    confirmpassword: function () {
      const vm = this;
      vm.$refs.signupPassword2.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/signup`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/signup`;
      }
    },
    signupBtn() {
      const vm = this;

      // Divide Phone Number

      let countryCode = vm.allPhone
        .substr(1)
        .substring(0, vm.allPhone.indexOf(" ") - 1);
      let phoneNum = vm.allPhone
        .substring(vm.allPhone.indexOf(" "), vm.allPhone.length)
        .replace(/\s*/g, "");

      const signupinfo = {
        Email: vm.email,
        VerificationCode: vm.verificationcode,
        MemberName: vm.name,
        Mobile: phoneNum,
        MobileCountryCode: countryCode,
        spass: vm.password,
        CSRF: vm.CSRF_Token,
      };

      const url = "https://www.chanchao.com.tw/apiLogin2/signup";

      vm.$validator.validate().then((valid) => {
        if (valid) {
          if (vm.password.length > 7) {
            if (vm.checkedrule) {
              vm.$http.post(url, signupinfo).then(function (response) {
                if (response.data == "200") {
                  vm.alertTitle = "Đăng ký thành công";
                  vm.alertText =
                    "Cảm ơn sự gia nhập của bạn, hãy đăng nhập ngay bây giờ để tận hưởng nhiều dịch vụ độc quyền hơn";
                  vm.alertSuccessSignup();
                } else if (response.data == "252") {
                  vm.alertText = "Bạn đã đăng ký trùng lặp！";
                  vm.alertError();
                  vm.$refs.signupEmail.style.borderColor = "red";
                } else if (response.data == "253") {
                  vm.alertText = "Mã xác nhận không đúng！";
                  vm.alertError();
                  vm.$refs.signupPassword.style.borderColor = "red";
                } else if (response.data == "254") {
                  window.location.replace("https://www.chanchao.com.tw/vn/");
                } else {
                  vm.alertText = "Hệ thống đang bận, vui lòng đăng nhập sau！";
                  vm.alertError();
                }
              });
            } else {
              vm.alertText = "Bạn chưa chọn đồng ý với điều khoản dịch vụ！";
              vm.alertError();
              vm.checkText = true;
            }
          } else {
            vm.alertText = "Mật khẩu 8-20 ký tự！";
            vm.alertError();
            vm.$refs.password.style.borderColor = "red";
            vm.$refs.signupPassword2.style.borderColor = "red";
          }
        } else {
          vm.alertText =
            "Thông tin chưa hoàn thiện, xin vui lòng kiểm tra lại！";
          vm.alertError();
        }
      });
    },

    getverification() {
      const vm = this;

      vm.$validator.validate("email").then((valid) => {
        if (valid) {
          const url = "https://www.chanchao.com.tw/apiLogin2/verification/vn";

          const verificationemail = {
            Email: vm.email,
            CSRF: vm.CSRF_Token,
          };

          vm.$http.post(url, verificationemail).then(function (response) {
            if (response.data == "200") {
              vm.alertText = `Mã xác nhận đã được gửi đến hộp thư của bạn！${vm.email}`;

              vm.alertSuccess();
            } else if (response.data == "252") {
              vm.alertText = "Địa chỉ email đã từng bị sử dụng để đăng ký！";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "Vui lòng nhập email chính xác";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "254") {
              window.location.replace("https://www.chanchao.com.tw/vn/");
            } else if (response.data == "255") {
              vm.alertText =
                "Sorry, you have entered an invalid email domain name. Please reconfirm your email address and retrieve the code again.";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "256") {
              vm.alertText =
                "Sorry, we do not allow disposable email addresses, please use another email address.";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else {
              vm.alertText = "Hệ thống đang bận, vui lòng đăng nhập sau！";
              vm.alertError();
            }
          });
        } else {
          // 如果 email 驗證失敗，顯示錯誤訊息
          vm.alertText = "email phải là một địa chỉ email hợp lệ";
          vm.alertError();
          vm.$refs.signupEmail.style.borderColor = "red";
        }
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
    alertError() {
      const vm = this;
      vm.$swal({
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccessSignup() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        if (vm.lastUrl.length > 0) {
          window.location.replace(vm.lastUrl);
        } else {
          window.location.replace("https://www.chanchao.com.tw/vn/member"); //注意能否直接到會員中心頁
        }
      });
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //取得上頁網址(from cookie)
    if (vm.$cookies.get("url")) {
      vm.lastUrl = vm.$cookies.get("url");

      // console.log(vm.lastUrl)
    } else {
      vm.lastUrl = "https://www.chanchao.com.tw/vn/member";
    }

    //取得網址內信箱及認證碼

    let getUrlString = location.href;
    let getParams = new URL(getUrlString);

    let memberid = getParams.searchParams.get("e");
    let vCode = getParams.searchParams.get("v");

    vm.email = memberid;
    vm.verificationcode = vCode;

    //更換英文語系
    vm.$i18n.locale = "vi";
  },
};
</script>

<style lang="scss" scoped>
//Swal setting

.logoText {
  font-size: 20px;
}

.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 10px;
}
.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
  font-family: Arial;
}

.title_family {
  font-family: "sans-serif";
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.lineRight {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.navLogo {
  height: 55px;
}

.navHead {
  font-size: 29px;
  color: #2c3e50;
}

.navCnt {
  font-size: 17px;
}

@media (max-width: 768px) {
  .navLogo {
    height: 50px;
  }
  .lineRight {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .navHead {
    font-size: 23px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 14px;
  }

  .logoText {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.linkText {
  position: relative;
}

.linkLine {
  position: absolute;
  height: 13px;
  //width: 33px;
  top: 20%;
  left: 0;
  border-left: 2px solid #a1a7a8;
}
</style>
